module.exports = __webpack_public_path__ + "assets/img/03a.30c3f975.jpg";